import { NextPage } from 'next'
import { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { Box } from '@mui/material'
import { NewsDetailUrl } from '../common/url'
import ReactLoading from 'react-loading'
import { isDesktop, isTablet } from 'react-device-detect'
import '../common/styles.css'

const ExternalHtmlWithScript = ({ htmlContent }) => {
    useEffect(() => {
        const script = document.createElement('script')
        script.src = 'https://cdn.ckeditor.com/ckeditor5/29.0.0/classic/ckeditor.js' // 如果脚本是外部的
        script.async = true
        document.body.appendChild(script)

        return () => {
            document.body.removeChild(script)
        }
    }, [])

    useEffect(() => {
        const style = document.createElement('style')
        style.innerHTML = `
          li {
            margin-left: 20px;
          }
        `
        document.head.appendChild(style)
    
        // 清理工作
        return () => {
          document.head.removeChild(style)
        }
      }, [])
    
    return (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    )
}

export const NewsDetail: NextPage = () => {

    const [data, setData] = useState(null)

    const containerRef = useRef(null)

    // 动态修复表格样式
    useEffect(() => {
        if (containerRef.current) {
          // 移除所有内联样式
          const tables = containerRef.current.querySelectorAll('table')
          tables.forEach(table => {
            table.removeAttribute('style') // 移除内联样式
            table.style.width = '100%' // 强制设置宽度为 100%
          })
    
          // 移除列宽设置
          const cols = containerRef.current.querySelectorAll('col')
          cols.forEach(col => {
            col.removeAttribute('style')
            col.removeAttribute('width')
          })
    
          // 移除所有内联单元格宽度
          const cells = containerRef.current.querySelectorAll('td, th')
          cells.forEach(cell => {
            cell.removeAttribute('style')
            cell.removeAttribute('width')
          })
        }
      }, [])

    useEffect(() => {
        let mounted = true
        const fetchData = async () => {
            try {
                const id = new URL(window.location.href).searchParams.get('id')
                if (id !== null) {
                    try {
                        const response = await axios.get(NewsDetailUrl + id)
                        if (mounted) {
                            setData(response.data['data'])
                        }
                    } catch (error) {
                        console.error(error)
                    }
                }
            } catch (error) {
                console.error(error)
            }
        }

        fetchData()

        return () => {
            mounted = false
        }
    }, [])

    return (
        <>
            {data === null ?
                (<Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    paddingTop: '200px',
                    paddingBottom: '200px',
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center'
                }}>
                    <ReactLoading type={'spokes'} width={'32px'} height={'32px'} color={'#FFC107'}></ReactLoading>
                </Box>)
                :
                (isDesktop ? (<Box sx={{ paddingLeft: '120px', paddingRight: '120px', paddingTop: '30px', paddingBottom: '30px' }}>
                    <div >
                        <ExternalHtmlWithScript htmlContent={'<div id="preview" class="ck-content">' + data['attributes']['details'] + '</div>'} />
                    </div>
                </Box>) : (<Box sx={{ paddingLeft: isTablet ? '12px' : '0px', paddingRight: isTablet ? '12px' : '0px', paddingTop: '10px', paddingBottom: '30px' }}>
                    <div className="promotion-container" ref={containerRef}>
                        <div dangerouslySetInnerHTML={{ __html: data['attributes']['details'] }} />
                    </div>
                </Box>)
                )
            }
        </>
    )
}
